import {Component, inject, OnInit} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { AuthService } from "../../services/auth.service";
import { NotificationService } from "../../services/notification.service";

@Component({
  selector: 'app-login',
  templateUrl: './set-password.component.html',
  styleUrls: ['./set-password.component.scss'],
})
export class SetPasswordComponent implements OnInit {
  showOldPassword: boolean = false;
  showPassword: boolean = false;
  showConfirmPassword: boolean = false;
  
  slides = [
    { image: "assets/images/news1.png", text: "Explore Legal and Public Announcements From Government" },
    { image: "assets/images/news2.png", text: "Explore Your Digital Source of Government Information" },
  ];
  
  currentIndex = 0;
  interval: any;
  
  private fb: FormBuilder = inject(FormBuilder);
  private authService: AuthService = inject(AuthService);
  private notificationService: NotificationService = inject(NotificationService);
  private router: Router = inject(Router);
  
  form: FormGroup;
  loading = false;

  constructor() { }

  ngOnInit() {
    // Check if user is authenticated
    if (!this.authService.isAuthenticated()) {
      this.notificationService.errorSnackbar("Please login first");
      this.router.navigate(['/auth/login']);
      return;
    }

    this.form = this.fb.group({
      oldPassword: ['', [Validators.required]],
      newPassword: ['', [Validators.required, Validators.minLength(8)]],
      confirmPassword: ['', Validators.required],
    }, { validator: this.passwordsMatchValidator });

    this.interval = setInterval(() => {
      this.currentIndex = (this.currentIndex + 1) % this.slides.length;
    }, 3000);
  }

  ngOnDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  // Custom validator to check newPassword === confirmPassword
  private passwordsMatchValidator(group: FormGroup) {
    const newPassword = group.get('newPassword')?.value;
    const confirmPassword = group.get('confirmPassword')?.value;
    return newPassword === confirmPassword ? null : { passwordsMismatch: true };
  }

  // Function to submit change password
  async changePassword() {
    if (this.form.invalid) {
      if (this.form.hasError('passwordsMismatch')) {
        this.notificationService.errorSnackbar("Passwords do not match");
      } else {
        this.notificationService.errorSnackbar("Please fill all fields correctly");
      }
      
      // Mark all fields as touched to show validation errors
      Object.keys(this.form.controls).forEach(key => {
        this.form.get(key)?.markAsTouched();
      });
      
      return;
    }

    this.loading = true;

    const formData = {
      oldPassword: this.form.value.oldPassword,
      newPassword: this.form.value.newPassword
    };

    try {
      const response = await this.authService.changePassword(formData);
      
      this.notificationService.successSnackbar("Password changed successfully!");
      
     
      
    } catch (error: any) {
      console.error("❌ Change password error:", error);
      
     
    } finally {
      this.loading = false;
    }
  }

  toggleShowPassword(field: string) {
    if (field === 'old') this.showOldPassword = !this.showOldPassword;
    if (field === 'new') this.showPassword = !this.showPassword;
    if (field === 'confirm') this.showConfirmPassword = !this.showConfirmPassword;
  }

  prev() {
    this.currentIndex = this.currentIndex === 0 ? this.slides.length - 1 : this.currentIndex - 1;
  }

  next() {
    this.currentIndex = (this.currentIndex + 1) % this.slides.length;
  }

  cancel() {
    this.router.navigate(['/dashboard']);
  }

  // Getters for easy form access in template
  get oldPassword() {
    return this.form.get('oldPassword');
  }

  get newPassword() {
    return this.form.get('newPassword');
  }

  get confirmPassword() {
    return this.form.get('confirmPassword');
  }
}